import styled from '@emotion/styled';
import { tokens, Tooltip } from '@hotjar/hotsauce';

type BorderRadius = 'rounded' | 'circle';

type Cursor = 'pointer' | 'default';

interface ButtonProps {
  size: number;
  format: BorderRadius;
  outline: boolean;
  cursor: Cursor;
}

interface Props {
  tooltipText: string;
  number: number;
  format?: BorderRadius;
  size?: number;
  outline?: boolean;
  cursor?: Cursor;
  className?: string;
}

const BORDER_RADIUS_MAP: Record<BorderRadius, string> = {
  rounded: '4px',
  circle: '50%',
} as const;

const getSize = ({ size }: ButtonProps) => `${size}px`;
const getBorderRadius = ({ format }: ButtonProps) => BORDER_RADIUS_MAP[format];
const getShadow = ({ outline }: ButtonProps) =>
  outline ? `0 0 0 1px ${tokens.color.white}` : 'none';
const getCursor = ({ cursor }: ButtonProps) => cursor;

const Button = styled('span', { shouldForwardProp: (prop: string) => prop === 'children' })`
  background-color: ${tokens.color.neutral_300};
  border-radius: ${getBorderRadius};
  box-shadow: ${getShadow};
  color: ${tokens.color.text_default};
  cursor: ${getCursor};
  display: block;
  font-size: 10px;
  font-weight: 600;
  height: ${getSize};
  line-height: ${getSize};
  text-align: center;
  text-decoration: none;
  width: ${getSize};
`;

export const MoreButton = ({
  format = 'circle',
  number,
  size = 24,
  tooltipText,
  outline = false,
  cursor = 'pointer',
  className,
}: Props): JSX.Element => {
  return (
    <Tooltip text={tooltipText}>
      <Button size={size} format={format} outline={outline} cursor={cursor} className={className}>
        +{number}
      </Button>
    </Tooltip>
  );
};
